import React from 'react';
import { Icon, Tooltip } from '~/components';
import { colors } from '~/styles';

export default function LineTypeTooltip({ line }) {
  if (!line.project) {
    return (
      <Tooltip message="This ad-hoc line is not associated with a project.">
        <Icon icon="exclamation-triangle" color={colors.warning} />
      </Tooltip>
    );
  }
  switch (line.transactionType) {
    case 'time':
      if (line.timeEntries.length === 0)
        return (
          <Tooltip
            message={`This line was associated with time entries that no longer exist on the ${line.project.name} project. It will be converted to an ad-hoc line upon save.`}>
            <Icon icon="clock" color={colors.warning} />
          </Tooltip>
        );

      return (
        <Tooltip message={`This line is associated with time entries on the ${line.project.name} project.`}>
          <Icon icon="clock" color={colors.grey40} />
        </Tooltip>
      );

    case 'milestone':
      if (line.milestones.length === 0)
        return (
          <Tooltip
            message={`This line was associated with fixed fee milestones that no longer exist on the ${line.project.name} project. It will be converted to an ad-hoc line upon save.`}>
            <Icon icon="file-invoice-dollar" color={colors.warning} />
          </Tooltip>
        );

      return (
        <Tooltip message={`This line is associated with fixed fee milestones on the ${line.project.name} project.`}>
          <Icon icon="file-invoice-dollar" color={colors.grey40} />
        </Tooltip>
      );

    case 'expense':
      if (line.expenses.length === 0 && line.projectExpenses.length === 0)
        return (
          <Tooltip
            message={`This line was associated with expenses that no longer exist on the ${line.project.name} project. It will be converted to an ad-hoc line upon save.`}>
            <Icon icon="receipt" color={colors.warning} />
          </Tooltip>
        );

      return (
        <Tooltip message={`This line is associated with expenses on the ${line.project.name} project.`}>
          <Icon icon="receipt" color={colors.grey40} />
        </Tooltip>
      );

    case 'other_item':
      if (line.otherItems.length === 0)
        return (
          <Tooltip
            message={`This line was associated with other items that no longer exist on the ${line.project.name} project. It will be converted to an ad-hoc line upon save.`}>
            <Icon icon="file-alt" color={colors.warning} />
          </Tooltip>
        );

      return (
        <Tooltip message={`This line is associated with other items on the ${line.project.name} project.`}>
          <Icon icon="file-alt" color={colors.grey40} />
        </Tooltip>
      );

    case 'prepayment':
      if (!line.prepayments || line.prepayments.length === 0)
        return (
          <Tooltip
            message={`This line was associated with a prepayment that no longer exists on the ${line.project.name} project. It will be converted to an ad-hoc line upon save.`}>
            <Icon icon="money-bill-transfer" color={colors.warning} />
          </Tooltip>
        );

      return (
        <Tooltip message={`This line is associated with a prepayment on the ${line.project.name} project.`}>
          <Icon icon="money-bill-transfer" color={colors.grey40} />
        </Tooltip>
      );

    case 'prepayment_offset':
      return (
        <Tooltip
          message={`This line offsets fees on this invoice using prepaid amounts on the ${line.project.name} project.`}>
          <Icon icon="circle-minus" color={colors.grey40} />
        </Tooltip>
      );

    case 'product_item':
      if (line.productItems.length === 0)
        return (
          <Tooltip
            message={`This line was associated with products that no longer exist on the ${line.project.name} project. It will be converted to an ad-hoc line upon save.`}>
            <Icon icon="file-alt" color={colors.warning} />
          </Tooltip>
        );

      return (
        <Tooltip message={`This line is associated with products on the ${line.project.name} project.`}>
          <Icon icon="barcode" color={colors.grey40} />
        </Tooltip>
      );

    case 'service_item':
      if (line.serviceItems.length === 0)
        return (
          <Tooltip
            message={`This line was associated with additional services that no longer exist on the ${line.project.name} project. It will be converted to an ad-hoc line upon save.`}>
            <Icon icon="file-invoice-dollar" color={colors.warning} />
          </Tooltip>
        );

      return (
        <Tooltip message={`This line is associated with additional services on the ${line.project.name} project.`}>
          <Icon icon="file-invoice-dollar" color={colors.grey40} />
        </Tooltip>
      );

    default:
      return (
        <Tooltip message={`This ad-hoc line is associated with the ${line.project.name} project.`}>
          <Icon icon="edit" color={colors.grey40} />
        </Tooltip>
      );
  }
}
